import { render, staticRenderFns } from "./DecorDetail.vue?vue&type=template&id=5cb174e4&scoped=true"
import script from "./DecorDetail.vue?vue&type=script&lang=js"
export * from "./DecorDetail.vue?vue&type=script&lang=js"
import style0 from "./DecorDetail.vue?vue&type=style&index=0&id=5cb174e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb174e4",
  null
  
)

export default component.exports